var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"deep-edit-team-from-tournament-wrapper"},[(_vm.isLoadingTeam)?_c('div',{staticClass:"loading-wrapper"},[_c('b-spinner',{staticClass:"spinner"})],1):[_c('h3',[_vm._v("Команда: "+_vm._s(_vm.teamData.name))])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }